import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  List,
  ListItem,
  ListIcon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaCheckCircle, FaChartLine, FaLock, FaRocket } from 'react-icons/fa';

const Whitepaper = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Container maxW="container.xl" py={10}>
      <VStack spacing={8} align="stretch">
        <Box textAlign="center" mb={8}>
          <Heading as="h1" size="2xl" mb={4}>
            HODL Token Whitepaper
          </Heading>
          <Text fontSize="xl" color="gray.500">
            A Revolutionary Token Rewarding Long-Term Holders
          </Text>
        </Box>

        <Box bg={bgColor} p={8} borderRadius="lg" boxShadow="lg" borderWidth="1px" borderColor={borderColor}>
          <Heading as="h2" size="xl" mb={6}>
            Executive Summary
          </Heading>
          <Text mb={4}>
            HODL is a unique token that incentivizes long-term holding through an innovative reward mechanism.
            Built on the Solana blockchain and leveraging the power of the Internet Computer Protocol (ICP),
            HODL combines the best of both worlds to create a secure, efficient, and rewarding ecosystem.
          </Text>
          <Text>
            Our mission is to promote sustainable token economics by rewarding those who believe in the
            long-term vision of the project. Through our unique integration of Solana and ICP, we've created
            a system that is both secure and efficient, while maintaining the benefits of both blockchains.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
          <Box bg={bgColor} p={8} borderRadius="lg" boxShadow="lg" borderWidth="1px" borderColor={borderColor}>
            <Heading as="h3" size="lg" mb={4}>
              Technical Architecture
            </Heading>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={FaCheckCircle} color="green.500" />
                Solana Smart Contract for token mechanics
              </ListItem>
              <ListItem>
                <ListIcon as={FaCheckCircle} color="green.500" />
                ICP Backend for reward distribution
              </ListItem>
              <ListItem>
                <ListIcon as={FaCheckCircle} color="green.500" />
                Secure cross-chain communication
              </ListItem>
              <ListItem>
                <ListIcon as={FaCheckCircle} color="green.500" />
                Automated reward distribution system
              </ListItem>
            </List>
          </Box>

          <Box bg={bgColor} p={8} borderRadius="lg" boxShadow="lg" borderWidth="1px" borderColor={borderColor}>
            <Heading as="h3" size="lg" mb={4}>
              Token Economics
            </Heading>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={FaChartLine} color="blue.500" />
                Fair launch through Moonit bonding curve
              </ListItem>
              <ListItem>
                <ListIcon as={FaLock} color="blue.500" />
                No team allocation or pre-mine
              </ListItem>
              <ListItem>
                <ListIcon as={FaRocket} color="blue.500" />
                Rewards based on holding duration
              </ListItem>
              <ListItem>
                <ListIcon as={FaCheckCircle} color="blue.500" />
                Transparent and verifiable distribution
              </ListItem>
            </List>
          </Box>
        </SimpleGrid>

        <Box bg={bgColor} p={8} borderRadius="lg" boxShadow="lg" borderWidth="1px" borderColor={borderColor}>
          <Heading as="h2" size="xl" mb={6}>
            Reward Mechanism
          </Heading>
          <Text mb={4}>
            The HODL token implements a unique reward mechanism that incentivizes long-term holding:
          </Text>
          <List spacing={3}>
            <ListItem>
              <ListIcon as={FaCheckCircle} color="green.500" />
              Rewards are distributed automatically to token holders
            </ListItem>
            <ListItem>
              <ListIcon as={FaCheckCircle} color="green.500" />
              Reward rate increases with holding duration
            </ListItem>
            <ListItem>
              <ListIcon as={FaCheckCircle} color="green.500" />
              Minimum holding period of 24 hours required
            </ListItem>
            <ListItem>
              <ListIcon as={FaCheckCircle} color="green.500" />
              Transparent and verifiable reward distribution
            </ListItem>
          </List>
        </Box>

        <Box bg={bgColor} p={8} borderRadius="lg" boxShadow="lg" borderWidth="1px" borderColor={borderColor}>
          <Heading as="h2" size="xl" mb={6}>
            Security and Compliance
          </Heading>
          <Text mb={4}>
            Security is our top priority. We've implemented multiple layers of protection:
          </Text>
          <List spacing={3}>
            <ListItem>
              <ListIcon as={FaLock} color="green.500" />
              Audited smart contracts
            </ListItem>
            <ListItem>
              <ListIcon as={FaLock} color="green.500" />
              Secure cross-chain communication
            </ListItem>
            <ListItem>
              <ListIcon as={FaLock} color="green.500" />
              Regular security assessments
            </ListItem>
            <ListItem>
              <ListIcon as={FaLock} color="green.500" />
              Compliance with regulatory requirements
            </ListItem>
          </List>
        </Box>
      </VStack>
    </Container>
  );
};

export default Whitepaper; 